<template>
  <div>
    <div class="text-center theFooter">
      <small>Version 0.4.5</small>
      <br>
      <small>22.04.2019</small>
      <br>

      <small>
        <a href="#/help">Help</a>
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheFooter"
};
</script>

<style>
.theFooter {
  background-color: #f2f2f2;
  color: black;
  border-top: solid 2px #cecece;
}
</style>
